import React, { useState } from "react";
import {
  Code,
  Database,
  Server,
  Smartphone,
  Monitor,
  Palette,
} from "lucide-react";
import "./Skills.css";
import html from "../../assets/skills/html.png";
import ant from "../../assets/skills/ant.png";
import css from "../../assets/skills/css.png";
import electron from "../../assets/skills/electron.png";
import expo from "../../assets/skills/expo.png";
import express from "../../assets/skills/express.png";
import firebase from "../../assets/skills/firebase.png";
import js from "../../assets/skills/js.png";
import MongoDB from "../../assets/skills/mongodb.png";
import mui from "../../assets/skills/mui.png";
import mysql from "../../assets/skills/mysql.png";
import native from "../../assets/skills/native.png";
import node from "../../assets/skills/node.png";
import postGreSql from "../../assets/skills/posgresql.png";
import scss from "../../assets/skills/scss.png";
import tailwind from "../../assets/skills/tailwind.png";
import TypeScript from "../../assets/skills/typescript.png";
import ReactJS from "../../assets/skills/react.png";
import NextJS from "../../assets/skills/nextjs.png";
import git from "../../assets/skills/git.png";
import GitHub from "../../assets/skills/github.png";
import vercel from "../../assets/skills/vercel.png";
import netlify from "../../assets/skills/netlify.png";
import render from "../../assets/skills/render.png";

const Skills = () => {
  const [activeTab, setActiveTab] = useState("web");
  const skillCategories = {
    web: {
      title: "Web Development",
      icon: <img src={html} alt="web" width={24} height={24} loading="lazy" />,
      skills: [
        { name: "HTML5", level: 95, icon: html },
        { name: "CSS3", level: 90, icon: css },
        { name: "JavaScript ES6+", level: 88, icon: js },
        { name: "React", level: 85, icon: ReactJS },
        { name: "Next JS", level: 85, icon: NextJS },
        { name: "TypeScript", level: 85, icon: TypeScript },
      ],
    },
    database: {
      title: "Database",
      icon: (
        <img src={MongoDB} alt="db" width={24} height={24} loading="lazy" />
      ),
      skills: [
        { name: "MongoDB", level: 90, icon: MongoDB },
        { name: "MySQL", level: 82, icon: mysql },
        { name: "PostgreSQL", level: 78, icon: postGreSql },
        { name: "Firebase Firestore", level: 85, icon: firebase },
      ],
    },
    server: {
      title: "Server Technologies",
      icon: (
        <img src={node} alt="server" width={24} height={24} loading="lazy" />
      ),
      skills: [
        { name: "Node.js", level: 90, icon: node },
        { name: "Express.js", level: 88, icon: express },
      ],
    },
    mobile: {
      title: "Mobile Applications",
      icon: (
        <img src={native} alt="mobile" width={24} height={24} loading="lazy" />
      ),
      skills: [
        { name: "React Native", level: 85, icon: native },
        { name: "Expo", level: 82, icon: expo },
      ],
    },
    desktop: {
      title: "Desktop Applications",
      icon: (
        <img
          src={electron}
          alt="desktop"
          width={24}
          height={24}
          loading="lazy"
        />
      ),
      skills: [{ name: "Electron.js", level: 80, icon: electron }],
    },
    ui: {
      title: "UI/UX Design",
      icon: (
        <img src={tailwind} alt="ui" width={24} height={24} loading="lazy" />
      ),
      skills: [
        { name: "Tailwind CSS", level: 92, icon: tailwind },
        { name: "SCSS", level: 88, icon: scss },
        { name: "Material-UI", level: 85, icon: mui },
        { name: "Ant Design", level: 87, icon: ant },
      ],
    },
    versioning: {
      title: "Versioning & Deployment",
      icon: (
        <img
          src={GitHub}
          alt="versioning & Deployment"
          width={24}
          height={24}
          loading="lazy"
        />
      ),
      skills: [
        { name: "Git", level: 95, icon: git },
        { name: "GitHub", level: 90, icon: GitHub },
        { name: "Google Firebase", level: 88, icon: firebase },
        { name: "Netlify", level: 85, icon: netlify },
        { name: "Vercel", level: 85, icon: vercel },
        { name: "Render", level: 85, icon: render },
      ],
    },
  };

  const tabs = [
    { key: "web", label: "Web" },
    { key: "database", label: "Database" },
    { key: "server", label: "Server" },
    { key: "mobile", label: "Mobile" },
    { key: "desktop", label: "Desktop" },
    { key: "ui", label: "UI/UX" },
    { key: "versioning", label: "Versioning & Deployment" },
  ];

  return (
    <section className="skills-section">
      <div className="container">
        <div className="skills-header">
          <h2 className="skills-title">Technical Skills</h2>
          <p className="skills-subtitle">
            My expertise across different technologies
          </p>
        </div>

        <div className="skills-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`skills-tab ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {skillCategories[tab.key].icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="skills-content">
          <div className="skills-category-header">
            <div className="category-icon">
              {skillCategories[activeTab].icon}
            </div>
            <h3 className="category-title">
              {skillCategories[activeTab].title}
            </h3>
          </div>
          <div className="skills-grid">
            {skillCategories[activeTab].skills.map((skill, index) => (
              <div
                key={index}
                className="skill-card"
                style={{ "--delay": `${index * 100}ms` }}
              >
                <div className="skill-content">
                  <img
                    src={skill.icon}
                    alt={skill.name}
                    className="skill-img"
                    loading="lazy"
                  />
                  <div className="skill-text">
                    <span className="skill-name">{skill.name}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
